import React from 'react';
import { AuthRoles } from "components/auth";

export const MenuControlConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/menu_control`,
            component: React.lazy(() => import('./MenuControl'))
        }
    ]
};